import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Box, Typography, Link, IconButton } from '@mui/material';
import { CloseOutlined, PhoneAndroidOutlined } from '@mui/icons-material';
import getMobileOS from '@helpers/getMobileOs';
import RepeatAppDownloadModal from '@components/Modals/RepeatAppDownloadModal/RepeatAppDownloadModal';
import { useFeature } from 'flagged';
const useStyles = makeStyles()((theme) => ({
    root: {
        position: 'relative',
        display: 'flex',
        zIndex: 1,
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: '#1e1e1f',
        color: 'white',
        padding: theme.spacing(1.5, 2),
    },
    left: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
    },
    icon: {
        fontSize: 36,
    },
    text: {
        display: 'flex',
        flexDirection: 'column',
    },
    title: {
        fontSize: 13,
        fontWeight: 500,
    },
    link: {
        color: '#2196f3',
        fontSize: 14,
        fontWeight: 500,
        textDecoration: 'none',
        cursor: 'pointer',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    closeButton: {
        color: '#a0a0a0',
    },
}));
const AppDownloadMobileSection = () => {
    const { classes } = useStyles();
    const [isDisplay, setIsDisplay] = useState(true);
    const [isShow, setIsShow] = useState(false);
    const shouldHideDownloadMobileAppButton = !!useFeature('disable_download_mobile_app_button');
    if (shouldHideDownloadMobileAppButton) {
        return _jsx(_Fragment, {});
    }
    let href;
    const mobileOS = getMobileOS();
    if (mobileOS === 'android') {
        href = process.env.REPEAT_APP_DOWNLOAD_GOOGLE_PLAY_URL;
    }
    else if (mobileOS === 'ios') {
        href = process.env.REPEAT_APP_DOWNLOAD_APP_STORE_URL;
    }
    const handleClose = () => {
        setIsDisplay(false);
    };
    const openStoreURL = () => {
        if (href) {
            globalThis.open(href, '_blank');
        }
        else {
            setIsShow(true);
        }
    };
    return isDisplay ? (_jsxs(_Fragment, { children: [_jsxs(Box, { className: classes.root, children: [_jsxs(Box, { className: classes.left, children: [_jsx(PhoneAndroidOutlined, { className: classes.icon }), _jsxs(Box, { className: classes.text, children: [_jsx(Typography, { variant: "body1", className: classes.title, children: "Repeat mobile app out now" }), _jsx(Link, { component: "a", onClick: openStoreURL, className: classes.link, children: "Continue" })] })] }), _jsx(IconButton, { className: classes.closeButton, onClick: handleClose, children: _jsx(CloseOutlined, { fontSize: "large" }) })] }), _jsx(RepeatAppDownloadModal, { show: isShow, handleClose: () => setIsShow(false) })] })) : null;
};
export default AppDownloadMobileSection;
